import { FC } from 'react';
import * as Sentry from '@sentry/react';
import styled from 'styled-components';
import tw from 'twin.macro';

import { Background, NoDataInfo } from '@/components';
import HouseImage from '@/assets/images/image-house.webp';
import strings from '@/language/Swedish';
import { useRouteError } from 'react-router-dom';

const PageContainer = styled.div`
  ${tw`flex h-screen`};
`;

const Page = styled.main`
  ${tw`relative flex flex-col flex-1 overflow-y-auto sm:p-4 sm:gap-4`}
`;

const ErrorPage: FC = () => {
  const error = useRouteError();

  Sentry.captureException(error);

  return (
    <PageContainer>
      <Background />
      <Page>
        <NoDataInfo
          heading={strings.data.somethingWentWrong}
          altText={strings.data.somethingWentWrong}
          text={strings.errorPage.errorSummary}
          img={HouseImage}
        />
      </Page>
    </PageContainer>
  );
};

export default ErrorPage;
